import axios from "axios"
import { API_URL } from "../config"
import { toast } from "react-toastify"
import { authHeader } from "./auth-header"

const API = API_URL() + "api/"

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
	response => {
		return response
	},
	error => {
		if (error.response.status === 401) {
			toast.warning("Tu sesión ha expirado")
			localStorage.removeItem("ssid")
			setTimeout(() => {
				window.location = "/"
			}, 1000)
		} else {
			console.log(error)
		}
	}
)

const getPeriodosAdmin = () => {
	const URL = API + "admin/periodos"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const getUnidadesAdmin = () => {
	const URL = API + "admin/unidades"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const getUsersAdmin = () => {
	const URL = API + "admin/usuarios"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const setConfirmaSerie = (val, user) => {
	const URL = API + "admin/set_valida_serie"
	const data = {
		valida_serie: val,
		usuario: user
	}
	return axiosInstance
		.post(URL, data, authHeader())
		.then(response => response)
		.catch(err => console.log(err))
}

const getTiposUnidad = () => {
	const URL = API + "admin/tipos_unidad"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const createUnidad = (data, id = null) => {
	let newData = data
	if (id) {
		newData = { id: id, ...data }
	}
	console.log(newData)
	const URL = API + "admin/unidad"
	return axiosInstance
		.post(URL, newData, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const deleteUnidad = unidadId => {
	const URL = API + `admin/unidad/${unidadId}`
	return axiosInstance
		.delete(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const createOrEditVotacion = (data, id = null) => {
	let newData = data
	let URL = API + "admin/set_periodo"
	if (id) {
		newData = { id: id, ...data }
		URL = API + "admin/update_periodo"
	}
	console.log(newData)
	return axiosInstance
		.post(URL, newData, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const getUnidades = () => {
	const URL = API + "admin/unidades"
	return axiosInstance
		.get(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const deletePeriodo = periodoId => {
	const URL = API + `admin/delete_periodo/${periodoId}`
	return axiosInstance
		.delete(URL, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

const aperturaProceso = id => {
	const URL = API + "admin/tricel_open_proceso"
	return axiosInstance
		.post(URL, { id: id }, authHeader())
		.then(({ data }) => data)
		.catch(err => console.log(err))
}

export {
	getPeriodosAdmin,
	getUnidadesAdmin,
	getUsersAdmin,
	setConfirmaSerie,
	getTiposUnidad,
	createUnidad,
	deleteUnidad,
	createOrEditVotacion,
	getUnidades,
	deletePeriodo,
	aperturaProceso
}
